// 2. 判断DOM元素的class样式中是否已存在要添加的className
function hasClass(oldClass, newclass) {
  let flag = false
  const reg = new RegExp('(^|\\s)' + newclass + '(\\s|$)')
  flag = reg.test(oldClass)
  return flag
}

export function addClass(element, newclass) {
  const oldClass = element.$el ? element.$el.className : element.className
  if (!hasClass(oldClass, newclass)) {
    const newClassName = oldClass + ' ' + newclass
    if (element.$el) {
      element.$el.className = newClassName
    } else {
      element.className = newClassName
    }
  }
}
export function removeClass(element, removeclass) {
  const oldClass = element.$el ? element.$el.className : element.className
  if (hasClass(oldClass, removeclass)) {
    const oldArr = oldClass.split(' ')
    oldArr.splice(oldArr.indexOf(removeclass), 1)
    if (element.$el) {
      element.$el.className = oldArr.join(' ')
    } else {
      element.className = oldArr.join(' ')
    }
  }
}
